// extracted by mini-css-extract-plugin
module.exports = {"areaLateral":"style_areaLateral__2S81K","btnRetractExpand":"style_btnRetractExpand__3WnLq","expanded":"style_expanded__1wKYN","textRecolherMenu":"style_textRecolherMenu__3gcyb"};